export default class Navigation {
	last_hash: string;

	replaceHash(item: string): void {
		const new_hash = `#${item}`;
		if (new_hash !== this.last_hash) {
			history.replaceState(null, document.title, new_hash);
			this.last_hash = new_hash;
		}
	}

	pushHash(item: string): void {
		const new_hash = `#${item}`;
		if (new_hash !== this.last_hash) {
			history.pushState(null, document.title, new_hash);
			this.last_hash = new_hash;
		}
	}

	updateHash(item: string): void {
		this.last_hash = `#${item}`;
	}

	updateFilters(filterIds: string[]): void {
		const url = new URL(window.location.href);
		url.searchParams.delete("filter");
		for (const id of filterIds) {
			url.searchParams.append("filter", id);
		}
		window.history.pushState(null, null, url);
	}

	static getURLParams(): URLSearchParams {
		return new URLSearchParams(window.location.search)
	}

	static parseURLFilters(): string[] {
		const url_params = Navigation.getURLParams();
		if (url_params.size) {
			return url_params.getAll("filter");
		}
		return [];
	}
}